var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('img',{staticClass:"vue-map w-full h-auto",attrs:{"src":_vm.source,"alt":"Main Event Location Map"}})])}
var staticRenderFns = []

export { render, staticRenderFns }